import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';
import { getApps, initializeApp } from 'firebase/app';
import { Logger } from './AnalyticsInterface';
import { isServerSide } from './AnalyticsUtil';
import { getClientConfig } from '../Config/ClientConfig';

export const FirebaseLogger: Logger = {
  name: 'Firebase',
  init: async () => {
    if (isServerSide()) {
      return;
    }

    if (getApps().length > 0) {
      // Already initialized
      return;
    }

    const { firebaseConfig } = await getClientConfig();
    const config = firebaseConfig;

    if (!config) return;

    initializeApp(config);
  },
  identify: (superProps) => {
    if (isServerSide()) {
      return;
    }

    const analytics = getAnalytics();
    setUserProperties(analytics, superProps);
  },
  logEvent: (name, props) => {
    if (isServerSide()) {
      return;
    }

    const analytics = getAnalytics();
    logEvent(analytics, name, props);
  },
  logError: (name, props) => {
    if (isServerSide()) {
      return;
    }

    const analytics = getAnalytics();
    const finalProps = {
      error_title: name,
      ...props,
    };
    logEvent(analytics, 'error_logged', finalProps);
  },
};
